import * as React from "react";
import {
  SecondaryButton,
  InformationBanner,
} from "@graffer-inc/console-design-kit";
import { FormWrapperPropsV2 } from "@graffer-inc/form-generator";
import {
  PaymentSettingV2,
  ProcedureDetailType,
} from "@graffer-inc/cloud-gov-core";
import { BaseModal } from "../../../../../atoms/base-modal";
import { FormGeneratorV2 } from "@graffer-inc/form-generator";
import { CalcPaymentResult, useInspectorModal } from "./use-inspector-modal";
import { PaymentSettingInspectorResult } from "./result";

export type PaymentSettingInspectorModalProps = {
  onClose: () => void;
  procedureId: string;
  procedureDetail: ProcedureDetailType;
};

export const PaymentSettingInspectorModal: React.FC<
  PaymentSettingInspectorModalProps
> = ({ onClose, procedureId, procedureDetail }) => {
  const { formProps, paymentResult, paymentSetting } = useInspectorModal(
    procedureId,
    procedureDetail,
  );
  return (
    <PaymentSettingInspectorModalInner
      onClose={onClose}
      formProps={formProps}
      paymentResult={paymentResult}
      paymentSetting={paymentSetting}
    />
  );
};

export type PaymentSettingInspectorModalInnerProps = {
  onClose: () => void;
  formProps: FormWrapperPropsV2;
  paymentResult: CalcPaymentResult;
  paymentSetting: PaymentSettingV2 | undefined;
};

export const PaymentSettingInspectorModalInner: React.FC<
  PaymentSettingInspectorModalInnerProps
> = ({ onClose, formProps, paymentResult, paymentSetting }) => {
  return (
    <BaseModal isActive title="決済金額の検証" onClose={onClose}>
      <section className="modal-card-body">
        {paymentSetting?.items?.length ? (
          <>
            <PaymentSettingInspectorResult paymentResult={paymentResult} />
            <div className="field">
              <label className="label">決済に関わる入力項目</label>
              <FormGeneratorV2 {...formProps} />
            </div>
          </>
        ) : (
          <InformationBanner message="決済設定がありません。" />
        )}
      </section>
      <footer className="columns modal-card-foot is-centered">
        <SecondaryButton text="キャンセル" onClick={onClose} />
      </footer>
    </BaseModal>
  );
};
